import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { RootApplicationAction } from '../state/actions';

export const useDispatcher = () => {
  return useDispatch<Dispatch<RootApplicationAction>>();
};
